var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$wait.is('loading'))?_c('div',[(_vm.presentation)?_c('PresentationDetails',_vm._b({attrs:{"is-live-app-redirect":_vm.isLiveAppOpen,"poster-index-route-name":"slug-abstracts"},on:{"message-count-update":_vm.handleMessageCountUpdate,"open-contact-presenter-modal":_vm.openContactPresenterModal,"scroll-to-comments":_vm.scrollToComments,"toggle-bookmark":_vm.toggleBookmark,"toggle-upvote":_vm.toggleUpvote}},'PresentationDetails',{
      form: _vm.form,
      presentation: _vm.presentation,
      presentationMedia: _vm.presentationMedia,
      presentationTitle: _vm.presentationTitle,
      pageType: _vm.pageType,
      allRooms: _vm.allRooms,
      allSchedulePresentations: _vm.allSchedulePresentations,
      focusMessageId: _vm.focusMessageId,
      isOrganizer: _vm.isOrganizer,
      isParticipant: _vm.isParticipant,
      isAllowedToVirtualCall: _vm.isAllowedToVirtualCall,
      arePresentationsVisible: _vm.arePresentationsVisible,
    },false)):_vm._e(),_vm._v(" "),_c('Portal',{attrs:{"to":"media-viewer"}},[_c('MediaViewer',{attrs:{"context":{ presentationTitle: _vm.presentationTitle, presentationMedia: _vm.presentationMedia },"poster-index-route-name":"slug-abstracts"}},[_c('NuxtChild')],1)],1),_vm._v(" "),_c('ContactPresenterModal',{ref:"contactPresenterModal",attrs:{"presentation":_vm.presentation,"form":_vm.form}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }